import { Component, computed, inject, input, OnInit } from '@angular/core';
import type { ReviewEntryComponentRendering } from '@reviews/models';
import { Store } from '@ngrx/store';
import { getDroplinkValue } from '@core/jss-utils';
import type { GetReviewsV1Data } from '@integration/api-client/reviews';
import { reviewActions, selectReviewsWithStatistics } from '@reviews/entity';
import { ReviewsEntrySectionComponent } from '@reviews/ui/sections';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-review-entry-section-container',
  standalone: true,
  templateUrl: 'review-entry-section-container.component.html',
  imports: [ReviewsEntrySectionComponent, ContentSectionComponent],
})
export class ReviewEntrySectionContainerComponent implements OnInit {
  readonly rendering = input<ReviewEntryComponentRendering>();

  readonly theme = computedContentSectionTheme(this.rendering);

  readonly #store = inject(Store);

  readonly location = computed<GetReviewsV1Data['location'] | undefined>(() => {
    const category = getDroplinkValue(
      this.rendering()?.fields,
      'reviewCategory'
    );
    return category ? (category as GetReviewsV1Data['location']) : undefined;
  });

  readonly id = computedContentSectionId(this.rendering);
  readonly fields = computed(() => this.rendering()?.fields);
  readonly title = computed(() => this.fields()?.title);
  readonly button = computed(() => this.fields()?.buttonLink);
  readonly showSummaryOnly = computed(
    () => this.fields()?.showSummaryOnly?.value ?? false
  );

  readonly reviews = this.#store.selectSignal(selectReviewsWithStatistics);

  ngOnInit() {
    const lastTwoReviewsWithRatingHigherThan6Payload: GetReviewsV1Data = {
      page: 1,
      amountOfReviews: 2,
      minimumScore: 7,
      location: this.location(),
    };

    this.#store.dispatch(
      reviewActions.getReviewsV1.requestAction({
        actionId: 'review-entry-section',
        payload: lastTwoReviewsWithRatingHigherThan6Payload,
      })
    );
  }
}
